const makePayments = {
  requires_2fa_on_new_session: `Se requiere autenticación de dos factores para reconectar esta cuenta.`,
  requires2fa_newsession: `Se requiere autenticación de dos factores para reconectar esta cuenta.`,
  wealthreader_reconnect_widget_title: `Completa la autenticación de dos factores`,
  select_payment_gateway: "Seleccionar pasarela de pago",
  connect_payment_gateway: `Conectar pasarela de pago`,
  manual_payment_via_csv: "Pago manual (CSV)",
  manual_payment_via_csv_description:
    "Descargue una plantilla CSV previamente completada basada en los documentos seleccionados, ingrese los detalles de pago y cargue el archivo para procesar el pago.",
  sepa_template: "Plantilla SEPA",
  sepa_template_description:
    "Ingrese el nombre del titular de la cuenta y el IBAN para generar un archivo de plantilla compatible con SEPA para transferencias bancarias europeas.",
  payment_gateway: "Pasarela de pago",
  payment_gateway_description:
    "Procese pagos instantáneamente a través de sus cuentas bancarias vinculadas. Seleccione entre las pasarelas de pago disponibles.",
  please_select_payment_gateway: "Por favor seleccione una pasarela de pago",
  connect_bank: "Conectar banco",
  please_select_bank: "Por favor seleccione su banco",
  payment_template: "Plantilla de pago",
  payment_template_description:
    "Genere plantillas de pago bancario en formatos compatibles para procesar pagos a través de su banco.",
  sepa_template_card_description:
    "Formato estándar para transferencias del Área Única de Pagos en Euros (PAIN.001)",
  please_select_payment_template: "Por favor seleccione una plantilla de pago",
  supplier_accountholdername_notfound:
    "No se encontró el nombre del titular de la cuenta del proveedor",
  select_payment_method: `Elija cómo desea procesar el pago seleccionando uno de los métodos de pago disponibles a continuación.`,
  template_type: `Tipo de plantilla`,
  payment_template_is_required: `Se requiere la plantilla de pago`,
  debitor_account_holder_required: `Se requiere el titular de la cuenta deudora`,
  debitor_iban_required: `Se requiere el IBAN del deudor`,
  supplier_currency_notfound: `No se encontró la moneda del proveedor`,
  payment_template_generated_successfully: `Plantilla de pago generada exitosamente`,
  "document(s)_ids_required": `Se requieren los IDs de los documentos`,
  debitor_accountholdername_required: `Se requiere el nombre del titular de la cuenta deudora`,
  duedate_required: `Se requiere la fecha de vencimiento`,
  supplier_not_created: `El proveedor no fue creado`,
  supplier_iban_notfound: `No se encontró el IBAN del proveedor`,
  "selected_document(s)_status_shouldbe_processedorreviewed": `El estado del documento seleccionado debe ser procesado o revisado`,
  "selected_document(s)_doctype_shoudbe_invoice": `El tipo de documento seleccionado debe ser factura`,
  "selected_document(s)_shouldbe_approved": `El documento seleccionado debe estar aprobado`,
  "selected_document(s)_shouldnotbe_sepaexported": `El documento seleccionado no debe estar exportado como SEPA`,
  "selected_document(s)_acountclass_shoudbe_accountpayable": `La clase de cuenta del documento seleccionado debe ser cuenta por pagar`,
  "selected_document(s)_paymentstatus_shoudbe_unpaidordue": `El estado de pago del documento seleccionado debe ser no pagado o vencido`,
  "selected_document(s)_vendorcompanyid_shoudnotbe_empty": `El ID de la empresa del proveedor del documento seleccionado no debe estar vacío`,
  "selected_document(s)_shoudbe_same_supplier_vendor": `El documento seleccionado debe ser del mismo proveedor/vendedor`,
  "selected_document(s)_shoudbe_same_supplier/vendor": `El documento seleccionado debe ser del mismo proveedor/vendedor`,
  select_account: `Seleccione la cuenta bancaria`,
  gateway_not_connected: `Pasarela de pago no conectada. Por favor conecte su cuenta bancaria para proceder con los pagos.`,
  bank_not_selected: `No se ha seleccionado ningún banco. Por favor, seleccione un banco para sincronizar las transacciones.`,
  fetching_bankdetail: `Obteniendo los detalles bancarios. Esto puede tardar algún tiempo.`,
  "selected_document(s)_shoudhave_customercompanyname": `Los documentos seleccionados deben contener el nombre de la empresa cliente`,
  "selected_document(s)_shoudbe_same_customercompanyid": `Los documentos seleccionados deben tener el mismo ID de empresa cliente`,
  "selected_document(s)_customercompanyid_shoudnotbe_empty": `El ID de la empresa cliente de los documentos seleccionados no debe estar vacío`,
  supplier_document_expired: `El documento del proveedor ha expirado`,
  consider_individual_transaction: `Considerar transacción individual`,
  bank_already_connected: `El banco ya está conectado`,
  payment_not_supported: `Pago no compatible`,
  wealthreader_relogin: `Los datos de acceso a su cuenta bancaria han cambiado, por lo que la conexión ya no es válida. Desconecte y vuelva a conectar su cuenta bancaria con las credenciales actualizadas para reanudar la sincronización de transacciones.`,
  sync_history: `Historial de sincronización`,
  view_sync_history: `Ver historial de sincronización`,
  syncStartedOn: `Sincronización iniciada`,
  syncCompletedOn: `Sincronización completada`,
  dateFrom: `Fecha desde`,
  error_message: `Mensaje de error`,
  error_category: `Categoría de error`,
  WealthreaderTransactionSyncJob: `Sincronización de transacciones del lector de patrimonio`,
  RequiresLiveAction: `Requiere acción en vivo`,
  reconnect_your_bank_account: `Vuelve a autenticar tu cuenta bancaria de {{bankName}}`,
  enter_your_credentials_to_receive_an_otp: `Introduce tus credenciales. Recibirás un código OTP para completar la autenticación.`,
};

export default makePayments;
